import React from "react";

import { ReactComponent as PdfIcon } from "src/images/pdf-alt.svg";
import { ReactComponent as PptxIcon } from "src/images/pptx.svg";
import { ReactComponent as XlsxIcon } from "src/images/xlsx.svg";

export default function TypeIcon({ type }) {
  switch (type) {
    case "xls":
      return <XlsxIcon />;
    case "pptx":
      return <PptxIcon />;
    case "pdf":
      return <PdfIcon />;
    default:
      return null;
  }
}
